module.exports = __webpack_public_path__ + "static/media/guide-smell-1.c8848c33.svg";